// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "segment".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "segment" table (1:1 with a DB row, on the wire). */
export const segmentAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    name: z.string(),
    filterJson: z.unknown(),
    isDynamic: z.boolean(),
    createdById: z.string().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    deletedAt: z.string().datetime().nullable(),
});
//# sourceMappingURL=segment.js.map